import React from "react";
import Profile from "./components/Profile";
import Footer from "./components/Footer";

import Navbar from "./components/Navbar";

function App() {
  return (
    <>
      <Navbar />
      <Footer />
    </>
  );
}

export default App;
